import { icons } from '../components/Icons';
import { CustomPaper } from '../components/Layout/CustomPaper';
// import { LayoutUnauthenticated } from '../components/LayoutUnauthenticated';
import { authClient } from '../lib/authClient';
import { routes } from '../routes';
// import useUser from '../hooks/useUser';
import { standardSchemaResolver } from '@hookform/resolvers/standard-schema';
// import * as icons from '../components/Icons';
// import { AirbrakeContext } from '../withAirbrake';
import {
  Alert,
  Anchor,
  Box,
  Button,
  PasswordInput,
  Space,
  TextInput,
  Title,
} from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { BadgeX } from 'lucide-react';
import { useEffect } from 'react';
// import { showNotification } from '@mantine/notifications';
// import LogRocket from 'logrocket';
// import React from 'react';
import { useForm } from 'react-hook-form';
import { Link, useLocation } from 'wouter';
import { z } from 'zod/v4';

const schema = z.object({
  email: z.string().email().min(1, 'A valid email address is required'),
  password: z.string().min(1, 'Password is required'),
});

export const Signin: React.FC = () => {
  // const context = useContext(SupabaseContext);
  // const { isLoading, user } = useUser();
  // const airbrake = useContext(AirbrakeContext);

  const {
    formState: { errors, isSubmitting },
    handleSubmit,
    register,
    setError,
  } = useForm<z.infer<typeof schema>>({
    resolver: standardSchemaResolver(schema),
  });

  const [, navigate] = useLocation();
  const { data: session, isPending } = authClient.useSession();

  useEffect(() => {
    if (session?.user && !isPending) {
      navigate(routes.home);
    }
  }, [isPending, navigate, session?.user]);

  // const submitHandler = handleSubmit(async (data) => {
  //   if (!context) {
  //     return;
  //   }

  //   const { error } = await context.supabase.auth.signInWithPassword(data);
  //   if (error) {
  //     LogRocket.captureMessage(error.message);
  //     airbrake?.notify(error);
  //     showNotification({
  //       ...icons.failure,
  //       message: error.message,
  //     });
  //   } else {
  //     navigate(routes.home, { replace: true });
  //   }
  // });

  // if (isLoading) {
  //   return null;
  // }

  const submitHandler = handleSubmit(async (formData) => {
    const { error } = await authClient.signIn.email({
      email: formData.email,
      password: formData.password,
    });

    // console.error(error);

    if (error) {
      setError('root', {
        message: error.message || 'An error occurred, please try again',
      });
    } else {
      notifications.show({
        message: (
          <>
            <icons.Success /> Sign in successful!
          </>
        ),
      });
      navigate('/', { replace: true });
    }
  });

  return (
    <CustomPaper>
      {/* <Alert
            color="yellow"
            p="lg"
            icon={<IoInformationCircleOutline size="2rem" />}
          >
            <Title order={5}>Clew is currently in closed beta.</Title>
            <Text align="justify" size="sm">
              We are currently accepting a limited number of new users on an
              invitation-only basis. If you are interested in participating in
              the closed beta, please sign up for our waitlist. We will notify
              you as soon as we have more slots available.
            </Text>
            <Space h="md" />
            <Title order={5}>Why closed beta?</Title>{' '}
            <Text align="justify" size="sm">
              We are still in the early stages of development, and we want to
              make sure that we are providing the best possible experience for
              our users. By limiting the number of users in the closed beta, we
              can focus on getting feedback from a small group of people and
              making sure that Clew is working as intended.
            </Text>
            <Space h="md" />
            <Title order={5}>What can you expect in the closed beta?</Title>
            <Text align="justify" size="sm">
              In the closed beta, you will have access to all of the features
              that are currently available in Clew. You will also be able to
              provide feedback on the app and help us to improve it. We are
              excited to share Clew with the world, and we appreciate your
              patience as we work to make it the best possible experience.
            </Text>
          </Alert> */}

      <Space h="sm" />
      <Box style={{ margin: '0 auto', maxWidth: '400px' }}>
        <Title order={3}>Sign in</Title>
        <Space h="sm" />
        {errors.root && (
          <>
            <Alert
              color="red"
              icon={<BadgeX />}
              title=""
              variant="filled"
            >
              {errors.root.message?.toString() ||
                'Unexpected error occurred, please try again'}
            </Alert>
            <Space h="sm" />
          </>
        )}
        <form
          noValidate
          onSubmit={submitHandler}
        >
          <TextInput
            error={errors?.email?.message?.toString()}
            label="Email address"
            type="email"
            {...register('email', {
              required: 'Please provide an email address',
            })}
          />
          <Space h="md" />
          <PasswordInput
            error={errors?.password?.message?.toString()}
            label="Password"
            {...register('password', {
              required: 'Please provide a password',
            })}
          />
          <Space h="xl" />
          <Button
            disabled={isSubmitting}
            loading={isSubmitting}
            type="submit"
          >
            Sign in
          </Button>
        </form>
        <Space h="xl" />
        <Anchor
          component={Link}
          to={routes.forgetPassword}
        >
          Reset password
        </Anchor>
        <Space h="sm" />
        <Anchor
          component={Link}
          to={routes.signUp}
        >
          Sign up
        </Anchor>
      </Box>
    </CustomPaper>
  );
};
